module.exports = [{"Shaft Min Length":false},{"Ring Min Length":false},{"Disc Min Diam":false},{"Ring Min Diam":false},{"Min Length":false},{"Min Height":true},{"Min Weight":true},{"Min Diam":false},{"Min Tons":true},{"Min Lbs":true},{"Min Id":true},{"Min Od":false},{"Min":true}]


//////////////////
// WEBPACK FOOTER
// ./src/config/minDim.json
// module id = 5431
// module chunks = 1